/** @jsxRuntime classic */
/** @jsx jsx */
import { useMemo } from 'react';
import { css, jsx } from '@emotion/react';

import Chip from '@mui/material/Chip';

import { getSpeakerColor } from '../../utils/speaker';

export default function SpeakerList({ meeting, speakers: _speakers }) {
  const speakers = useMemo(() => {
    if (_speakers?.length) return _speakers;
    if (!meeting?.text?.length) return [];
    let set = new Set();
    for (let text of meeting.text) {
      let _speakers = text.speaker.split(',');
      for (let speaker of _speakers) {
        set.add(speaker.trim());
      }
    }
    return Array.from(set);
  }, [meeting, _speakers]);

  return (
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
      `}
    >
      {speakers.map((s) => (
        <Chip
          key={s}
          label={s}
          style={{ backgroundColor: getSpeakerColor(s), color: '#FFF' }}
        />
      ))}
    </div>
  );
}
